import { useMemo } from "react";
import PropTypes from "prop-types";

const NotificationPanel = ({
  className = "",
  notificationPanelPadding,
  onSettingWifiContainerClick,
}) => {
  const notificationPanelStyle = useMemo(() => {
    return {
      padding: notificationPanelPadding,
    };
  }, [notificationPanelPadding]);

  return (
    <section
      className={`flex flex-row items-start justify-start pt-0 px-10 pb-1.5 box-border max-w-full text-left text-base text-light-text font-text-regular-lowercase ${className}`}
      style={notificationPanelStyle}
    >
      <div className="flex flex-col items-start justify-start gap-10 max-w-full mq360:gap-5">
        <div
          className="relative font-medium"
          onClick={onSettingWifiContainerClick}
        >
          Home
        </div>
        <div className="flex flex-col items-start justify-start gap-[15px] text-21xl text-dark-text">
          <div className="flex flex-row items-start justify-start gap-[3px]">
            <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
              Chào Nam
            </h1>
            <div className="flex flex-col items-start justify-start pt-[19px] px-0 pb-0">
              <img
                className="w-6 h-6 relative overflow-hidden shrink-0"
                loading="lazy"
                alt=""
                src="/mode-edit-outline.svg"
              />
            </div>
          </div>
          <div className="relative text-5xl font-semibold text-light-text">
            Máy của bé My sắp hết pin!
          </div>
        </div>
      </div>
    </section>
  );
};

NotificationPanel.propTypes = {
  className: PropTypes.string,

  /** Style props */
  notificationPanelPadding: PropTypes.string,

  /** Action props */
  onSettingWifiContainerClick: PropTypes.func,
};

export default NotificationPanel;
